<template>
  <aw-select
    :options="computedItems"
    :multiple="multiple"
    v-model="selectVal"
    :offset="[0, 10]"
    class="FormControl AmbiSelect"
    ul-class="dropdown-menu max-w-full max-h-96 overflow-y-auto"
    :class="{ 'is-valid': $formErrors[id] === undefined, 'is-invalid': $formErrors[id] }"
  >
    <template v-slot:btn="{ openSelect, closeSelect, searchInput, opened }">
      <div
        @click="opened ? closeSelect() : openSelect()"
        class="bg-white relative w-full text-left cursor-pointer dropdown-button flex items-center"
      >
        <span
          class="pl-3 text-sm"
          :class="{ 'text-gray-700': !searchInput.value }"
          @click.stop="opened ? closeSelect() : openSelect()"
        >
          <span v-if="searchInput.value">{{ searchInput.value }}</span>
          <span v-else-if="selectVal">{{ computedValWithoutMetaData }}</span>
          <span v-else>{{ searchInput.placeholder }}</span>
        </span>
        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <aw-icon icon="chevron-down" class="w-5 h-5 text-ambi-red" />
        </span>
      </div>
    </template>

    <template v-slot:items="{ option, removeOption }">
      <div
        class="bg-indigo-100 inline-flex items-center text-sm rounded mr-1 overflow-hidden cursor-pointer"
      >
        <span class="ml-2 mr-1 leading-relaxed truncate max-w-xs px-1">{{ option.label }}</span>
        <button
          class="w-6 h-8 inline-block align-middle text-gray-500 bg-indigo-200 focus:outline-none remove"
          @click.prevent.stop="removeOption(option)"
          tabindex="-1"
          title="Remove"
        >
          <svg
            class="w-6 h-6 fill-current mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
            />
          </svg>
        </button>
      </div>
    </template>
    <template v-slot:option="{ option, highlighted, selected, handleMouseEnter, selectOption }">
      <li
        role="option"
        class="cursor-pointer select-none relative py-2 px-4 truncate"
        :class="{ 'text-ambi-red': highlighted, 'text-gray-900': !highlighted }"
        @mouseenter="handleMouseEnter(option)"
        @click.stop="selectOption(option)"
        v-if="option.id"
      >
        <span
          class="font-normal block truncate"
          :class="{ 'font-semibold': selected, 'font-normat': !selected }"
        >
          {{ option.label }}
        </span>

        <span
          class="absolute right-4 top-2"
          :class="{ 'text-white': highlighted, 'text-indigo-600': !highlighted }"
          v-show="selected"
        >
          <div class="RadioIndicator -Selected">
            <span> <aw-icon icon="tick" class="w-5 h-5 text-white" /></span>
          </div>
        </span>

        <span
          class="absolute right-4 top-2"
          :class="{ 'text-white': highlighted, 'text-indigo-600': !highlighted }"
          v-show="!selected"
        >
          <div class="RadioIndicator">
            <span> <aw-icon icon="tick" class="w-5 h-5 text-white" /></span>
          </div>
        </span>
      </li>
    </template>
    <template v-slot:noresults>
      <li
        role="option"
        class="cursor-default select-none py-2 pl-8 pr-4 sticky -top-1 z-10 bg-red-50 -mt-1"
      >
        <span class="font-semibold block text-ambi-red"> Žádný výsledek nenalezen </span>
        <span class="absolute inset-y-0 left-0 flex items-center pl-1.5">
          <aw-icon icon="emoji-frown" class="h-5 w-5 text-ambi-red" />
        </span>
      </li>
    </template>
    <template v-slot:maxresults="{ maxOptions, filteredOptions }">
      <li
        role="option"
        class="cursor-default select-none py-2 pl-8 pr-4 sticky -top-1 z-10 bg-blue-50 -mt-1"
      >
        <span class="font-semibold block text-blue-400">
          {{
            $t(
              'Zobrazeno prvních %maxOptions% záznamů z %filteredOptionsLength%. Upřesněte hledaný výraz',
              { maxOptions: maxOptions, filteredOptionsLength: filteredOptions.length }
            )
          }}
        </span>
        <span class="absolute inset-y-0 left-0 flex items-center pl-1.5">
          <aw-icon icon="exclamation-circle" class="h-5 w-5 text-blue-400" />
        </span>
      </li>
    </template>
  </aw-select>

  <select :name="name" :value="selectVal" v-bind="$attrs" class="hidden" ref="select" :id="id">
    <option v-for="item in computedItems" :key="item.id" :value="item.id">
      {{ item.label }}
    </option>
  </select>

  <!-- <div class="invalid-feedback" v-if="$controls[id].hasErrors" :id="id + '_message'">
    <div v-for="(error, index) in $controls[id].getErrors" :key="index">{{ error }}</div>
  </div> -->
</template>

<script>
//import isEqual from 'lodash/isEqual'

export default {
  emits: ['update:modelValue'],
  props: {
    multiple: {
      default: false,
      type: Boolean
    },
    name: String,
    id: String,
    modelValue: [String, Number]
  },
  data() {
    return {}
  },
  computed: {
    computedValWithoutMetaData() {
      let label = this.computedItems.find(item => item.id === this.modelValue).label
      const patterns = [
        / – \d+ míst[ao]*/ // Pattern pro terminy ve smyslu Čt 3. 4. 2025 od 20:00 – 6 míst => Čt 3. 4. 2025 od 20:00
      ]

      for (const pattern of patterns) {
        label = label.replace(pattern, '')
      }

      return label
    },
    computedItems() {
      return this.$controls[this.id].items
    },

    selectVal: {
      get() {
        console.log('AmbiSelect selectVal', this.modelValue)
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
        console.log('trigger update?', val)
      }
    }
  },
  watch: {
    selectVal: {
      handler() {
        if (this.$refs.select) {
          this.$refs.select.dispatchEvent(new Event('change', { bubbles: true }))
        }
      },
      flush: 'post'
    }
  }
}
</script>
